import script from "./PlanInsertCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanInsertCom.vue?vue&type=script&setup=true&lang=js"

import "./PlanInsertCom.vue?vue&type=style&index=0&id=0ac09d5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac09d5f"]])

export default __exports__